'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _FromWidgetPostMessageApi = require('./FromWidgetPostMessageApi');

var _FromWidgetPostMessageApi2 = _interopRequireDefault(_FromWidgetPostMessageApi);

var _ToWidgetPostMessageApi = require('./ToWidgetPostMessageApi');

var _ToWidgetPostMessageApi2 = _interopRequireDefault(_ToWidgetPostMessageApi);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _MatrixClientPeg = require('./MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _SettingsStore = require('./settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _WidgetOpenIDPermissionsDialog = require('./components/views/dialogs/WidgetOpenIDPermissionsDialog');

var _WidgetOpenIDPermissionsDialog2 = _interopRequireDefault(_WidgetOpenIDPermissionsDialog);

var _WidgetUtils = require('./utils/WidgetUtils');

var _WidgetUtils2 = _interopRequireDefault(_WidgetUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!global.mxFromWidgetMessaging) {
    global.mxFromWidgetMessaging = new _FromWidgetPostMessageApi2.default();
    global.mxFromWidgetMessaging.start();
} /*
  Copyright 2017 New Vector Ltd
  Copyright 2019 Travis Ralston
  
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  */

/*
* See - https://docs.google.com/document/d/1uPF7XWY_dXTKVKV7jZQ2KmsI19wn9-kFRgQ1tFQP7wQ/edit?usp=sharing for
* spec. details / documentation.
*/

if (!global.mxToWidgetMessaging) {
    global.mxToWidgetMessaging = new _ToWidgetPostMessageApi2.default();
    global.mxToWidgetMessaging.start();
}

var OUTBOUND_API_NAME = 'toWidget';

var WidgetMessaging = function () {
    function WidgetMessaging(widgetId, widgetUrl, isUserWidget, target) {
        (0, _classCallCheck3.default)(this, WidgetMessaging);

        this.widgetId = widgetId;
        this.widgetUrl = widgetUrl;
        this.isUserWidget = isUserWidget;
        this.target = target;
        this.fromWidget = global.mxFromWidgetMessaging;
        this.toWidget = global.mxToWidgetMessaging;
        this._onOpenIdRequest = this._onOpenIdRequest.bind(this);
        this.start();
    }

    (0, _createClass3.default)(WidgetMessaging, [{
        key: 'messageToWidget',
        value: function messageToWidget(action) {
            action.widgetId = this.widgetId; // Required to be sent for all outbound requests

            return this.toWidget.exec(action, this.target).then(function (data) {
                // Check for errors and reject if found
                if (data.response === undefined) {
                    // null is valid
                    throw new Error("Missing 'response' field");
                }
                if (data.response && data.response.error) {
                    var err = data.response.error;
                    var msg = String(err.message ? err.message : "An error was returned");
                    if (err._error) {
                        console.error(err._error);
                    }
                    // Potential XSS attack if 'msg' is not appropriately sanitized,
                    // as it is untrusted input by our parent window (which we assume is Riot).
                    // We can't aggressively sanitize [A-z0-9] since it might be a translation.
                    throw new Error(msg);
                }
                // Return the response field for the request
                return data.response;
            });
        }

        /**
         * Request a screenshot from a widget
         * @return {Promise} To be resolved with screenshot data when it has been generated
         */

    }, {
        key: 'getScreenshot',
        value: function getScreenshot() {
            console.warn('Requesting screenshot for', this.widgetId);
            return this.messageToWidget({
                api: OUTBOUND_API_NAME,
                action: "screenshot"
            }).catch(function (error) {
                return new Error("Failed to get screenshot: " + error.message);
            }).then(function (response) {
                return response.screenshot;
            });
        }

        /**
         * Request capabilities required by the widget
         * @return {Promise} To be resolved with an array of requested widget capabilities
         */

    }, {
        key: 'getCapabilities',
        value: function getCapabilities() {
            var _this = this;

            console.warn('Requesting capabilities for', this.widgetId);
            return this.messageToWidget({
                api: OUTBOUND_API_NAME,
                action: "capabilities"
            }).then(function (response) {
                console.warn('Got capabilities for', _this.widgetId, response.capabilities);
                return response.capabilities;
            });
        }
    }, {
        key: 'sendVisibility',
        value: function sendVisibility(visible) {
            return this.messageToWidget({
                api: OUTBOUND_API_NAME,
                action: "visibility",
                visible: visible
            }).catch(function (error) {
                console.error("Failed to send visibility: ", error);
            });
        }
    }, {
        key: 'start',
        value: function start() {
            this.fromWidget.addEndpoint(this.widgetId, this.widgetUrl);
            this.fromWidget.addListener("get_openid", this._onOpenIdRequest);
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.fromWidget.removeEndpoint(this.widgetId, this.widgetUrl);
            this.fromWidget.removeListener("get_openid", this._onOpenIdRequest);
        }
    }, {
        key: '_onOpenIdRequest',
        value: async function _onOpenIdRequest(ev, rawEv) {
            var _this2 = this;

            if (ev.widgetId !== this.widgetId) return; // not interesting

            var widgetSecurityKey = _WidgetUtils2.default.getWidgetSecurityKey(this.widgetId, this.widgetUrl, this.isUserWidget);

            var settings = _SettingsStore2.default.getValue("widgetOpenIDPermissions");
            if (settings.deny && settings.deny.includes(widgetSecurityKey)) {
                this.fromWidget.sendResponse(rawEv, { state: "blocked" });
                return;
            }
            if (settings.allow && settings.allow.includes(widgetSecurityKey)) {
                var responseBody = { state: "allowed" };
                var credentials = await _MatrixClientPeg2.default.get().getOpenIdToken();
                (0, _assign2.default)(responseBody, credentials);
                this.fromWidget.sendResponse(rawEv, responseBody);
                return;
            }

            // Confirm that we received the request
            this.fromWidget.sendResponse(rawEv, { state: "request" });

            // Actually ask for permission to send the user's data
            _Modal2.default.createTrackedDialog("OpenID widget permissions", '', _WidgetOpenIDPermissionsDialog2.default, {
                widgetUrl: this.widgetUrl,
                widgetId: this.widgetId,
                isUserWidget: this.isUserWidget,

                onFinished: async function onFinished(confirm) {
                    var responseBody = { success: confirm };
                    if (confirm) {
                        var _credentials = await _MatrixClientPeg2.default.get().getOpenIdToken();
                        (0, _assign2.default)(responseBody, _credentials);
                    }
                    _this2.messageToWidget({
                        api: OUTBOUND_API_NAME,
                        action: "openid_credentials",
                        data: responseBody
                    }).catch(function (error) {
                        console.error("Failed to send OpenID credentials: ", error);
                    });
                }
            });
        }
    }]);
    return WidgetMessaging;
}();

exports.default = WidgetMessaging;
module.exports = exports['default'];
//# sourceMappingURL=WidgetMessaging.js.map